import { render } from "./NomenclatoareResurseUmane.vue?vue&type=template&id=722310f8&scoped=true&ts=true"
import script from "./NomenclatoareResurseUmane.vue?vue&type=script&lang=ts"
export * from "./NomenclatoareResurseUmane.vue?vue&type=script&lang=ts"

import "./NomenclatoareResurseUmane.vue?vue&type=style&index=0&id=722310f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-722310f8"]])

export default __exports__